import { render } from "./HomePart8.vue?vue&type=template&id=504336ba&scoped=true&ts=true"
import script from "./HomePart8.vue?vue&type=script&lang=ts"
export * from "./HomePart8.vue?vue&type=script&lang=ts"

import "./HomePart8.vue?vue&type=style&index=0&id=504336ba&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-504336ba"]])

export default __exports__